var Backbone = require('backbone')
var Config = require('config')
var App = require('app')
var BaseModel = require('src/common/base-model')

var Header = function () {

  // init
  var Header = BaseModel.extend({
    initialize: function () {}
  })

  var HeadersCollection = Backbone.Collection.extend({
    model: Header
  })

  // -- Methods
  var initializeHeaders = function () {
    App.entities.headers = new HeadersCollection([
      // { name: 'Status', url: 'status', navigationTrigger: 'contacts:list' },
      { name: 'Status', id: 'status', url: 'status', navigationTrigger: 'page-status:show', role: [] },
      { name: 'Clients', id: 'clients', url: 'clients', navigationTrigger: 'clients:list', role: ['super', 'admin'] },
      { name: 'Devices', id: 'devices', url: 'devices', navigationTrigger: 'page-devices:list', role: [] },
      { name: 'Reports', id: 'reports', url: 'reports', navigationTrigger: 'page-reports:list', role: [] }

    ])
  }

  // //
  var API = {
    getEntities: function (options) {
      if (App.entities.headers === undefined) {
        initializeHeaders()
      }
      return App.entities.headers
    }
  }

  App.globalChannel.reply({
    'header:entities': API.getEntities
  })

//
}

module.exports = Header



// WEBPACK FOOTER //
// ./js/entities/headers.js